var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMiniCasplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 385,
    viewBox: "0 0 334 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.79 0.729004L333.186 96.2443L257.812 139.82L258.526 244.159L333.162 287.309L167.792 382.872L2.35941 287.301L2.35938 96.2617L167.79 0.729004Z",
    fill: "#298968"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36035 96.272L167.982 192.038L2.36035 287.303V96.272Z",
    fill: "#157553"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.8 86.9275L258.612 139.358V244.207L167.8 296.649L76.9873 244.219V139.43L167.8 86.9275Z",
    fill: "#C5E1D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.8 86.9275V296.649L76.9878 244.379V139.433L167.8 86.9275Z",
    fill: "#A4C1B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.799 86.9275L258.612 139.358L167.8 191.788L76.9878 139.432L167.799 86.9275Z",
    fill: "#E4F1ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMiniCasplan);
export default __webpack_public_path__ + "static/media/logo-mini-casplan.7811809c81a7c9ecdf9fa2c4fff9bc3f.svg";
export { ForwardRef as ReactComponent };